import styled from "styled-components";

import mediaQueries from "themes/mediaQueries";

export const EditProfile = styled.div`
  @media (${mediaQueries.maxTablet}) {
    margin-top: 76px;
  }
`;
